var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1070_9454)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1070_9454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_1070_9454)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1070_9454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9956 46.5065C84.6516 47.6733 83.9804 48.7173 83.0615 49.515C82.1311 50.3881 81.2581 51.3223 80.3446 52.2101C80.2112 52.3305 80.1061 52.479 80.0369 52.6448C79.9677 52.8106 79.9361 52.9897 79.9444 53.1692C79.9569 56.8652 79.9209 60.5612 79.9613 64.2573C79.993 67.2933 78.8409 70.2224 76.7488 72.4242C74.1905 75.1447 70.9683 77.1537 67.3984 78.2541C63.135 79.6601 58.639 80.2255 54.16 79.919C50.44 79.7823 46.7746 78.9801 43.338 77.5504C39.6024 76.0737 36.4664 73.3938 34.4267 69.9353C34.3094 69.7351 34.2023 69.5291 34.1058 69.3181C34.022 69.1636 33.9867 68.9874 34.0045 68.8126C34.0223 68.6377 34.0924 68.4723 34.2057 68.3378C34.3131 68.1995 34.4589 68.0959 34.6249 68.0399C34.7908 67.9839 34.9697 67.978 35.139 68.023C36.3175 68.3238 37.5557 68.2985 38.7209 67.9496C39.8258 67.6019 40.7613 66.8549 41.3445 65.8547C42.0597 64.6695 42.4471 63.3158 42.4672 61.9319C42.4943 59.5787 42.4672 57.2248 42.4833 54.8715C42.4888 54.716 42.4604 54.5612 42.4001 54.4178C42.3397 54.2743 42.2488 54.1457 42.1338 54.0409C40.4266 52.3488 38.7171 50.6574 37.032 48.9433C36.5207 48.4477 36.1283 47.8429 35.8842 47.1742C35.6401 46.5055 35.5507 45.7903 35.6225 45.0821C35.6943 44.3739 35.9256 43.6912 36.2991 43.085C36.6725 42.4789 37.1784 41.9651 37.7787 41.5821C38.5626 41.0723 39.4826 40.8119 40.4175 40.8352C41.3524 40.8586 42.2583 41.1645 43.0157 41.7127C43.3469 41.9468 43.4129 41.869 43.5363 41.5381C46.0843 34.7139 50.9621 30.6224 58.0994 29.204C58.5363 29.1174 58.9805 29.0675 59.4211 29H62.9046C63.3452 29.0675 63.7857 29.1181 64.2263 29.204C70.9685 30.5248 75.7303 34.3184 78.4406 40.6414C78.6073 41.031 78.7695 41.1132 79.1749 41.0083C80.1096 40.7595 81.0986 40.8078 82.0045 41.1464C82.9105 41.485 83.6885 42.0971 84.2304 42.8977C84.5641 43.4311 84.823 44.0075 85 44.6111L84.9956 46.5065ZM36.6575 70.0556C36.9995 70.6134 37.3992 71.1339 37.85 71.6083C40.147 74.026 43.0481 75.7873 46.2539 76.7102C49.8457 77.794 53.5921 78.277 57.3416 78.1396C60.7454 78.0924 64.1177 77.4801 67.3206 76.3279C70.3585 75.3244 73.1057 73.5959 75.3243 71.292C77.0979 69.5053 78.1023 67.0967 78.1234 64.5801C78.1057 59.0445 78.1057 53.5087 78.1234 47.9726C78.1187 46.3144 77.8763 44.6655 77.4038 43.0761C76.307 39.1448 73.8147 35.7474 70.3932 33.519C66.9716 31.2907 62.855 30.3841 58.8131 30.9687C51.8212 32.0694 47.229 36.1624 44.9968 42.886C44.9317 43.0454 44.9202 43.2215 44.9642 43.388C45.0082 43.5544 45.1052 43.7019 45.2406 43.8084C46.7172 45.2627 48.1777 46.7325 49.6463 48.1993C49.7921 48.3338 49.9256 48.4811 50.045 48.6396C50.168 48.8185 50.2222 49.0358 50.1976 49.2515C50.1731 49.4672 50.0714 49.6668 49.9114 49.8136C49.7516 49.948 49.5506 50.0238 49.3418 50.0282C49.133 50.0326 48.929 49.9654 48.7637 49.8378C48.6233 49.7215 48.4906 49.5963 48.3664 49.4629C46.4074 47.5066 44.4564 45.5415 42.4863 43.5926C42.113 43.1865 41.6306 42.8963 41.0968 42.7568C40.5629 42.6173 40.0001 42.6344 39.4757 42.806C38.9892 42.9309 38.5475 43.1897 38.2008 43.5528C37.8541 43.916 37.6163 44.3691 37.5144 44.8606C37.3884 45.405 37.4138 45.9735 37.588 46.5045C37.7623 47.0354 38.0786 47.5086 38.5028 47.8728C40.4273 49.7696 42.3291 51.6884 44.2397 53.6014C44.373 53.726 44.4981 53.8591 44.6142 53.9998C44.7553 54.1461 44.8342 54.3414 44.8342 54.5446C44.8342 54.7478 44.7553 54.9431 44.6142 55.0895C44.5012 55.2194 44.416 55.371 44.3638 55.5351C44.3117 55.6991 44.2937 55.8721 44.311 56.0434C44.2735 58.2792 44.4314 60.5194 44.2228 62.7501C44.1013 64.3982 43.5181 65.9788 42.5399 67.3113C41.8643 68.2205 40.9728 68.9475 39.9459 69.4266C38.919 69.9057 37.7889 70.1219 36.6575 70.0556ZM79.9488 50.0726C80.9107 49.0644 81.8675 48.2631 82.6422 47.2916C83.0077 46.813 83.2133 46.2317 83.23 45.63C83.2468 45.0282 83.0737 44.4364 82.7354 43.9382C82.4029 43.4596 81.9362 43.0901 81.394 42.8761C80.8517 42.662 80.2582 42.6132 79.6882 42.7356C79.3284 42.8141 79.2322 42.9462 79.3291 43.3138C79.7926 45.078 80.0015 46.8993 79.9495 48.7225C79.94 49.1194 79.9488 49.5149 79.9488 50.0726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9892 48.0483C64.0692 49.6534 63.7045 51.2492 62.9364 52.6542C61.8454 54.4647 60.1356 54.4431 59.0545 52.6218C58.5019 51.6297 58.1711 50.5263 58.0855 49.3897C57.8905 47.7978 58.0299 46.182 58.4947 44.6488C58.6851 43.9962 58.9988 43.3874 59.4181 42.8564C59.5904 42.5963 59.8223 42.3825 60.0938 42.2333C60.3653 42.0842 60.6684 42.0042 60.977 42.0002C61.2856 41.9961 61.5906 42.0682 61.8659 42.2101C62.1411 42.3521 62.3782 42.5598 62.5571 42.8153C63.3056 43.8063 63.7662 44.9904 63.8869 46.2335C63.9731 46.8342 64.0073 47.4415 63.9892 48.0483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9892 48.0483C74.0692 49.6534 73.7045 51.2492 72.9364 52.6542C71.8454 54.4647 70.1356 54.4431 69.0545 52.6218C68.5019 51.6297 68.1711 50.5263 68.0855 49.3897C67.8905 47.7978 68.0299 46.182 68.4947 44.6488C68.6851 43.9962 68.9988 43.3874 69.4181 42.8564C69.5904 42.5963 69.8223 42.3825 70.0938 42.2333C70.3653 42.0842 70.6684 42.0042 70.977 42.0002C71.2856 41.9961 71.5906 42.0682 71.8659 42.2101C72.1411 42.3521 72.3782 42.5598 72.5571 42.8153C73.3056 43.8063 73.7662 44.9904 73.8869 46.2335C73.9731 46.8342 74.0073 47.4415 73.9892 48.0483Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1070_9454",
    x: -40,
    y: -45,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1070_9454"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.768627 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1070_9454",
    result: "effect2_dropShadow_1070_9454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1070_9454",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1070_9454",
    x: 0,
    y: -5,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1070_9454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1070_9454",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1070_9454",
    x: 18,
    y: 12,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1070_9454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1070_9454",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1070_9454",
    x1: 20,
    y1: 56.1733,
    x2: 96.5802,
    y2: 74.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5E5",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.d92c502e5b099c1689e7127b7ea259fe.svg";
export { ForwardRef as ReactComponent };